import React from 'react';

import { IRouter } from '@routers/interface';

export const routerResetPassword: IRouter = {
  path: '/reset-password/',
  loader: React.lazy(() => import('./index')),
  exact: true,
};
